// FIXME: substr, escape, event는 deprecated 됐기 때문에 수정이 필요
/* eslint-disable deprecation/deprecation */
import { message, Modal } from 'antd';
import cx from 'classnames';
import jwtDecode from 'jwt-decode';
import { differenceWith, forEach, get, includes, intersectionWith, isNil, random, replace, truncate } from 'lodash';
import isEqual from 'react-fast-compare';
import { POINT_RATE } from '../constants/service/app/pointConstants';
import {
  COLUMN_MIN_WIDTH,
  COLUMN_TEXT_WIDTH_SPACING,
  DATE_FORMAT,
  QUICK_DATE_SELECT_BUTTON_TARGET,
  SEARCH_PERIOD_BUTTON_ALL_TYPE,
} from '../constants/service/common/utilConstants';

import moment, { setDateFormat } from './moment';
import { REX_ADD_TEXT_FOR_NUMBER } from './rex';
import storage, { keys } from './storage';

/**
 * 서버로 데이터를 전송시 기본적인 form으로 만드는 함수
 */
export const setRequestForm = (requestData, isSpinner = false) => {
  return {
    data: requestData,
    isSpinner,
  };
};

/**
 * 첨부파일 또는 용량이 큰 데이터를 서버로 전송하기 위한 form 을 만드는 함수
 */
export const setMultipartForm = (requestData, isSpinner = false) => {
  const formData = new FormData();
  if (requestData.attachment) {
    forEach(requestData.attachment, (item, index) => {
      formData.append(index, item);
    });
  }

  formData.append('data', JSON.stringify(requestData));
  formData.append('isSpinner', isSpinner);

  return formData;
};

/**
 * 토큰 유효성 체크하기
 */
export const checkExpirity = (token) => {
  if (!token) {
    return null;
  }
  try {
    const profile = jwtDecode(token);
    const expiredAt = profile.expiredAt || profile.exp * 1000;
    if (expiredAt > new Date().getTime()) {
      return token;
    }
    return null;
  } catch (e) {
    storage.remove(keys.user);
    return null;
  }
};

/**
 * DnD를 이용하여 배열의 순서를 변경할 경우 사용
 */
export const reOrderArray = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * async 간단한 확인 모달
 */
export const asyncSimpleModal = (data) => {
  const { className, type = 'info', title, message, okText = '확인', cancelText = '아니오' } = data;

  return new Promise((resolve) => {
    const modal = Modal[type]({
      className: cx(className, 'amondz-simple-modal'),
      title,
      content: message,
      okText,
      cancelText,
      onOk() {
        resolve(true);
        modal.destroy();
      },
      onCancel() {
        resolve(false);
        modal.destroy();
      },
    });
  });
};

/**
 * store 를 path 로 업데이트
 */
export const updateStoreWithPath = (path, value, source) => {
  let schema = source;
  const len = path.length;
  for (let i = 0; i < len - 1; i++) {
    let elem = path[i];
    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }
  schema[path[len - 1]] = value;
};

/**
 * FIXME: 해당 코드는 formatNumberWithComma로 대체됨 수정이 필요
 * - `formatNumberWithComma`를 사용해 주세요.
 * - `unit`은 함수 외부에서 처리해 주세요
 *
 * 숫자에 천 단위마다 "," 붙이, 숫자에 단위 붓이기
 */
export const setNumberWithComma = (value, unit) => {
  if (isNil(value)) return '-';

  let result = value.toString().replace(REX_ADD_TEXT_FOR_NUMBER, ',');

  if (unit) result += unit;

  return result;
};

/**
 * "," 를 없애기
 */
export const setClearComma = (num) => {
  if (num) num = num.split(',').join('');

  return num;
};

/**
 * "-" 를 없애기
 */
export const setClearDash = (num) => {
  if (num) num = num.split('-').join('');

  return num;
};

/**
 * 이미지 정보 가져오기
 */
export const getImgInfo = (img) => {
  const reader = new FileReader();
  reader.readAsDataURL(img);
  return new Promise((resolve, reject) => {
    reader.addEventListener('load', () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = () =>
        resolve({
          url: reader.result,
          width: image.width,
          height: image.height,
        });
      image.onerror = (e) => {
        reject(e);
      };
    });
  });
};

/**
 * 새로운 브라우저 창을 열기
 */
export const openNewWindow = (url) => {
  window.open(url);
};

/**
 *  쿼리 스트링 파싱
 *  ?a=1&b=2 ==> {a:1, b:2}
 */
export const parseQueryString = () => {
  const queryString = window.location.search.substring(1).split('&');

  /**
   *  파싱할 쿼리 스트링이 없는 경우
   */
  if (queryString[0] === '') return {};

  const data = {};

  forEach(queryString, (item) => {
    const key = item.split('=', 2);

    if (key.length === 1) {
      data[key[0]] = '';
    } else {
      data[key[0]] = decodeURIComponent(key[1].replace(/\+/g, ' '));
    }
  });

  return data;
};

/**
 * 페이지 이동
 */
export const reDirectPage = (data) => {
  const { path, state } = data;
  if (state) {
    sessionStorage.setItem('navigationState', JSON.stringify(state));
  }
  window.location.href = path;
};

/**
 * 데이터가 없을 경우 "-" 으로 보이게 만들기
 */
export const setDash = (data) => {
  if (data) return data;
  return '-';
};

/**
 * input으로 들어오는 값
 */
export const setPhoneFormat = (num) => {
  if (!num) return null;

  num = num.toString().replace(/-/g, '');

  if (num.length === 8) {
    num = num.replace(/(\d{4})(\d{4})/, '$1-$2');
  } else if (num.length === 11) {
    num = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (num.indexOf('050') === 0) {
    if (num.length === 11) {
      num = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    } else {
      num = num.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  } else if (num.indexOf('02') === 0) {
    if (num.length === 9) {
      num = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    } else {
      num = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  } else {
    if (num.length === 10) {
      num = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    } else {
      num = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }

  return num;
};

/**
 * 시간을 해당 포맷으로 변경하기
 */
export const setTimeFormat = (time, format) => {
  if (!time) return '-';
  return moment.duration(time, 'second').format(format);
};

/**
 * 서버에 리스트 데이터 요청 후 search, searchOption, pagination, sortOption, filterOption 의 데이터를
 * reducer 로 보낼 객체 만들기
 */
export const setResponseListForm = (list, totalCnt = null, payload) => {
  const { searchOption, filterOption, sortOption, pagination } = payload;
  const responseListForm = {};

  /**
   *  리스트
   */
  responseListForm.list = list;

  /**
   *  검색 옵션
   */
  if (searchOption) responseListForm.searchOption = searchOption;

  /**
   *  필터 옵션
   */
  if (filterOption) responseListForm.filterOption = filterOption;

  /**
   *  정렬 옵션
   */
  if (sortOption) responseListForm.sortOption = sortOption;

  /**
   *  페이지네이션
   */
  if (pagination) {
    const pages = Math.ceil(totalCnt / pagination.pageSize);
    responseListForm.pagination = {
      pageNum: pagination.pageNum,
      pageSize: pagination.pageSize,
      pages: pages || 1,
    };
  }

  /**
   *  집계데이터
   */
  responseListForm.summary = {
    totalCnt,
  };

  return responseListForm;
};

/**
 * 서버에 리스트 데이터 요청 후 search, searchOption, pagination, sortOption, filterOption 의 데이터를
 * reducer 로 보낼 객체 만들기
 **/
export const _setResponseListForm = (list, totalCnt = null, payload) => {
  const { searchOption, filterOption, sortOption, pagination } = payload;
  const responseListForm = {};

  /**
   *  리스트
   */
  responseListForm.list = list;

  /**s
   *  검색 옵션
   */
  if (searchOption) responseListForm.searchOption = searchOption;

  /**
   *  필터 옵션
   */
  if (filterOption) responseListForm.filterOption = filterOption;

  /**
   *  정렬 옵션
   */
  if (sortOption) responseListForm.sortOption = sortOption;

  /**
   *  페이지네이션
   */
  if (pagination)
    responseListForm.pagination = {
      pageNum: pagination.pageNum,
      pageSize: pagination.pageSize,
      totalCnt,
    };

  return responseListForm;
};

/**
 * SELECT LIST 에 전체를 선택 할 수 있는 [전체] 항목을 추가하기
 */
export const addAllItemToSelectList = (selectList = [], name = '전체') => {
  return [
    {
      id: null,
      name,
    },
    ...selectList,
  ];
};

/**
 * 앞 뒤 공백 지우기
 */
export const setTrim = (data) => {
  if (data && data !== '') return data.trim();
  else return data;
};

/**
 * 난수 만들기
 */
export const getRandomNumber = () => {
  return random(10000000);
};

/**
 *  타겟팅된 props, state 의 변화 여부를 검사
 **/
export const comparePrePropsAndNextProps = (list) => {
  let result = 0;

  forEach(list, (item) => {
    result += !isEqual(item[0], item[1]);
  });

  return result > 0;
};

/**
 * 두 array 의 다른 element 리스트 가져오기
 **/
export const getDifferenceList = (aList, bList, aValue, bValue) => {
  return differenceWith(aList, bList, (a, b) => {
    const aTarget = !isNil(a[aValue]) ? a[aValue] : a;
    const bTarget = !isNil(b[bValue]) ? b[bValue] : b;
    return aTarget === bTarget;
  });
};

/**
 * 두 array 의 같은 element 리스트 가져오기
 **/
export const getIntersectionWith = (aList, bList, aValue, bValue, callback) => {
  if (typeof callback === 'function') {
    return intersectionWith(aList, bList, callback);
  }
  return intersectionWith(aList, bList, (a, b) => {
    const aTarget = a[aValue] ? a[aValue] : a;
    const bTarget = b[bValue] ? b[bValue] : b;
    return aTarget === bTarget;
  });
};

/**
 * 테이블 컬럼 길이 구하기
 */
export const setColumnWidth = (list, accessor) => {
  if (!list || !list.length) return COLUMN_MIN_WIDTH;

  const cellLength = Math.max(
    ...list.map((item) => {
      /**
       *  컬럼의 데이터 구하기
       */
      const value = get(item, accessor);

      /**
       *  number 면 string 으로 변환
       */
      if (typeof value === 'number') return value.toString().length;
      else return (value || '').length;
    }),
  );

  return Math.max(cellLength * COLUMN_TEXT_WIDTH_SPACING, COLUMN_MIN_WIDTH);
};

/**
 *  버튼 리스트에서 날짜 선택시
 *  각 버튼에 value 값에 따라서 날짜 데이터 만들어주기
 */
export const setQuickToDate = (data) => {
  const { id = null, value, target, type } = data;

  let period = { ...data.period };

  /**
   *  변경이 되는 날짜
   */
  const targetDate = setDateFormat(moment().add(value, 'day'), DATE_FORMAT.YMD_DASH_FORMAT);
  /**
   *  기준이 되는 날짜 (오늘)
   */
  const baseDate = setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT);

  if (!isNil(id) && !isNil(value)) {
    /**
     *  시작일자
     */
    if (target === QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE) {
      period = {
        startDate: targetDate,
        endDate: baseDate,
      };
    } else if (target === QUICK_DATE_SELECT_BUTTON_TARGET.END_DATE) {
      /**
       *  종료일자
       */
      period = {
        startDate: baseDate,
        endDate: targetDate,
      };
    }
  }

  return {
    quickDateIndex: id,
    period,
    type,
  };
};

/**
 * 버튼 리스트에서 날짜 선택시
 * 각 버튼에 value 값에 따라서 날짜 데이터 만들어주기
 * 검색 시작 시각은 00:00:00 종료 시각은 23:59:59
 */
export const setQuickToDateTime = (data) => {
  const { id = null, value, target, type } = data;

  let period = { ...data.period };

  if (!isNil(id) && !isNil(value)) {
    /**
     *  시작일자
     */
    if (target === QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE) {
      period = {
        startDate: setDateFormat(moment().add(value, 'day').startOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
        endDate: setDateFormat(moment().endOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
      };
    } else if (target === QUICK_DATE_SELECT_BUTTON_TARGET.END_DATE) {
      /**
       *  종료일자
       */
      period = {
        startDate: setDateFormat(moment().startOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
        endDate: setDateFormat(moment().add(value, 'day').endOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
      };
    }
  }

  return {
    quickDateIndex: id,
    period,
    type,
  };
};

/**
 *  excel 다운로드
 */
export const excelDownLoad = (fileName, bufferData) => {
  const buffer = new Uint8Array(bufferData.data);

  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 *  string 의 byte 값 구하기
 *  한글 : 2btye
 *  한글을 제외한 글자 : 1btye
 */
export const byteCount = (str) => {
  const contents = String(str);
  const contentsLength = contents.length;
  let charCount = 0;

  for (let k = 0; k < contentsLength; k++) {
    const strCharacter = contents.charAt(k);
    /**
     *  한글
     */
    if (escape(strCharacter).length > 4) {
      charCount += 2;
    } else charCount++;
    /**
     *  한글을 제외한 글자
     */
  }

  return charCount;
};

/**
 * 문자 ... 처리
 */
export const convertTextToShort = (text, receivedLength) => {
  if (typeof text === 'string') {
    /**
     *  한글 문자열 수
     */
    let korLength = 0;
    /**
     *  한글 포함 문자열의 총 길이 (한글은 2byte로 판정)
     */
    let korIncludeLength = 0;

    /**
     *  한글 문자열 수, 한글 포함 문자열 길이를 구함
     */
    for (let i = 0; i < text.length; i++) {
      if (escape(text.charAt(i)).length === 6) {
        korLength++;
        korIncludeLength++;
      }
      korIncludeLength++;

      /**
       *  한글 포함 문자열의 총 길이가 자를 문자열보다 커지면 break 함
       *  truncate() 가 문자열을 자르고 ...을 추가하기 때문에 문자열에 3을 더한 값으로 비교함
       */
      if (korIncludeLength + 3 > receivedLength) break;
    }

    /**
     *  자를 문자열 길이에 한글 문자열 수를 빼준다
     */
    text = truncate(text, { length: receivedLength - korLength });
  }

  return text;
};

/**
 * 상세 페이지 url 만들기
 */
export const setDetailPageUrl = (path, targetId) => {
  return replace(path, ':id', targetId);
};

/**
 * 값이 없으면 null 반환하기
 */
export const setIfNull = (data, targetProp = null, defaultValue = null) => {
  if (data) return targetProp ? data[targetProp] : data;
  else return defaultValue;
};

/**
 * 특정 단위 절사하기
 **/
export const roundDown = (number, decimals = 10) => {
  return Math.floor(number / decimals) * decimals;
};

/**
 *   비교하는 두 시간 사이에 있는 값인 계산하는 FUNC
 **/
export const checkIsBetween = (format, before, after, target) => {
  if (!before && !after) return true;
  if (!target) target = setDateFormat(new Date(), format);

  const currentTime = moment(target, format);
  const beforeTime = moment(moment(before), format);
  const afterTime = moment(moment(after), format);

  return currentTime.isBetween(beforeTime, afterTime, null, '[]');
};

/**
 *  선택된 리스트가 있는지 체크
 */
export const checkIsNonSelectedList = (list, text) => {
  if (list.length) return true;
  else message.error(text);
};

/**
 * 사업자등록번호 패턴 만들기
 */
export const setBusinessNumberFormat = (value) => {
  if (!value) return null;

  value = value.toString().replace(/-/g, '');

  if (value.length === 10) {
    value = value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
    return value;
  } else return value;
};

/**
 *  문자열에 포함되어있는 html 태그를 제거
 */
export const removeHtmlTag = (str) => {
  return str.replace(/(<([^>]+)>)/gi, '');
};

/**
 *  정해진 최대값을 넘어가면
 *  특정 문구로 설정하기
 */
export const setMaximumText = (amount, maximumAmount, word = '+') => {
  if (isNil(amount) || isNil(maximumAmount)) {
    return '-';
  }

  return maximumAmount < amount ? `${setNumberWithComma(maximumAmount, word)}` : setNumberWithComma(amount);
};

/**
 *  리스트를 TableTransfer 에 맞게 변경
 */
export const setUncheckableTableTransferList = (data) => {
  const { list, selectedIdList = [] } = data;

  /**
   *  치환
   */
  return list.map((item) => ({
    ...item,
    uncheckable: includes(selectedIdList, item.id),
  }));
};

/**
 * 금액별 포인트 적립금 계산
 */
export const calculatePoint = function (amount) {
  let result = Math.floor(amount * POINT_RATE);

  if (result < 0) {
    return 1;
  } else {
    return result;
  }
};

/**
 * 숫자만 입력하도록 event key 걸러내기
 */
export const numberKeyPress = (e) => {
  let key;
  if (window.event) key = window.event.keyCode;
  //IE
  else key = e.which; //firefox

  let event;
  event = e || window.event;
  if (key === 8 || key === 46 || key === 37 || key === 39) {
    // 건너뜀
  } else {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }
};

/**
 * 공백 체크
 **/
export const isBlank = (str) => {
  return !str || /^\s*$/.test(str);
};

/**
 * 검색 기간 설정하기
 */
export const setViewPeriod = (quickDateIndex, viewPeriod) => {
  if (!isNil(viewPeriod) && viewPeriod.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE) return viewPeriod;
  return null;
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const makeSelectList = (status, statusText) => {
  return Object.keys(status).map((key) => ({
    id: status[key],
    name: statusText[status[key]],
  }));
};
